
import { Component, Vue, Watch } from 'vue-property-decorator'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { querySetmealById, addSetmeal, editSetmeal } from '@/api/setMeal'
import { queryDishList } from '@/api/dish'
import { getCategoryList } from '@/api/category'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'addPromoSetmeal',
  components: {
    ImageUpload
  }
})
export default class extends Vue {
  private actionType: string = ''
  private imageUrl: string = ''
  /** 用户是否手动上传过封面（有则优先，否则回退主商品图） */
  private coverManual: boolean = false
  private detailImageUrl1: string = ''
  private detailImageUrl2: string = ''
  private detailImageUrl3: string = ''
  private detailImageUrl4: string = ''
  private detailImageUrl5: string = ''
  private dishOptions: any[] = []
  private dishCascaderOptions: any[] = []
  private dishCascaderProps = {
    value: 'value',
    label: 'label',
    children: 'children',
    emitPath: false,
    expandTrigger: 'hover' as const
  }
  private allCategoryFlat: any[] = []
  private giftTable: any[] = []
  private giftDialogVisible: boolean = false
  private pendingGiftDishId: any = null
  private homeDisplayOn: boolean = false
  private flashSaleOn: boolean = false
  private statusOn: boolean = false
  private mainUnitPrice: number = 0

  private ruleForm: any = {
    id: undefined,
    name: '',
    mainDishId: null,
    bucketCount: 10,
    price: '',
    specText: '',
    description: '',
    image: '',
    detailImage1: '',
    detailImage2: '',
    detailImage3: '',
    detailImage4: '',
    detailImage5: '',
    sort: 0,
    homeDisplay: 0,
    flashSale: 0,
    flashPrice: '',
    flashEndTime: '',
    status: 0,
    storeId: null
  }

  get selectedDishImage() {
    const dish = this.dishOptions.find(
      (d) => d && d.id != null && Number(d.id) === Number(this.ruleForm.mainDishId)
    )
    return (dish && dish.image) || ''
  }

  get coverPreviewUrl() {
    if (this.coverManual) {
      return this.imageUrl || ''
    }
    return this.selectedDishImage
  }

  /** 强制上传组件在商品/封面源变化时重挂载 */
  get coverUploadKey() {
    return `${this.ruleForm.id || 'new'}-${this.ruleForm.mainDishId || 0}-${
      this.coverManual ? 'm' : 'd'
    }-${this.coverPreviewUrl || ''}`
  }

  get rules() {
    return {
      name: {
        required: true,
        validator: (_rule: any, value: string, callback: Function) => {
          if (!value) {
            callback(new Error('请输入套餐名称'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      },
      mainDishId: {
        required: true,
        message: '请选择主商品',
        trigger: 'change'
      },
      bucketCount: {
        required: true,
        validator: (_r: any, value: number, callback: Function) => {
          if (!value || value < 1) {
            callback(new Error('请填写套餐桶数'))
          } else {
            callback()
          }
        },
        trigger: 'change'
      },
      price: {
        required: true,
        validator: (_rules: any, value: string, callback: Function) => {
          const reg = /^([1-9]\d{0,5}|0)(\.\d{1,2})?$/
          if (!reg.test(String(value)) || Number(value) < 0) {
            callback(new Error('价格格式有误'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    }
  }

  get currentStoreId() {
    const sid = UserModule.storeId
    if (!sid) return null
    const n = Number(sid)
    return Number.isNaN(n) ? null : n
  }

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    this.loadDishes().then(() => {
      if (this.actionType === 'edit') {
        this.init()
      }
    })
  }

  private getCategoryParentId(item: any) {
    if (!item) return null
    const p = item.parentId != null ? item.parentId : item.parent_id
    if (p == null || p === '' || Number(p) === 0) return null
    return Number(p)
  }

  private rebuildDishCascaderTree() {
    const nodes: Record<string, any> = {}
    ;(this.allCategoryFlat || []).forEach((c: any) => {
      if (!c || c.id == null) return
      nodes[String(c.id)] = {
        value: `c-${c.id}`,
        label: c.name || `分类#${c.id}`,
        children: [] as any[],
        _parentId: this.getCategoryParentId(c)
      }
    })

    const uncategorizedDishes: any[] = []
    this.dishOptions.forEach((d) => {
      const leaf = {
        value: Number(d.id),
        label: `${d.name || `商品#${d.id}`}（￥${Number(d.price || 0).toFixed(2)}）`
      }
      const ids = Array.isArray(d.displayCategoryIds) ? d.displayCategoryIds : []
      let mounted = false
      ids.forEach((cid: any) => {
        if (cid == null) return
        const key = String(cid)
        const node = nodes[key]
        if (!node) return
        if (!node.children.some((c: any) => Number(c.value) === leaf.value)) {
          node.children.push({ ...leaf })
        }
        mounted = true
      })
      if (!mounted) {
        uncategorizedDishes.push(leaf)
      }
    })

    const roots: any[] = []
    Object.keys(nodes).forEach((key) => {
      const node = nodes[key]
      const pid = node._parentId
      delete node._parentId
      if (pid != null && nodes[String(pid)]) {
        nodes[String(pid)].children.push(node)
      } else {
        roots.push(node)
      }
    })

    const sortAndPrune = (list: any[]): any[] => {
      const next = (list || [])
        .map((n) => {
          if (n == null) return null
          if (typeof n.value === 'number') return n
          const kids = sortAndPrune(n.children || [])
          if (!kids.length) return null
          return { ...n, children: kids }
        })
        .filter(Boolean) as any[]
      next.sort((a, b) => {
        const aLeaf = typeof a.value === 'number' ? 1 : 0
        const bLeaf = typeof b.value === 'number' ? 1 : 0
        if (aLeaf !== bLeaf) return aLeaf - bLeaf
        return String(a.label).localeCompare(String(b.label), 'zh-CN')
      })
      return next
    }

    const tree = sortAndPrune(roots)
    if (uncategorizedDishes.length) {
      uncategorizedDishes.sort((a, b) =>
        String(a.label).localeCompare(String(b.label), 'zh-CN')
      )
      tree.push({
        value: 'c-uncategorized',
        label: '未分类',
        children: uncategorizedDishes
      })
    }
    this.dishCascaderOptions = tree
  }

  private async loadDishes() {
    const storeId = this.currentStoreId
    if (!storeId) {
      this.$message.warning('请先在顶栏选择商户')
      this.dishOptions = []
      this.dishCascaderOptions = []
      this.allCategoryFlat = []
      return
    }
    try {
      const [catRes, dishRes]: any[] = await Promise.all([
        getCategoryList({ storeId, type: 1 }),
        queryDishList({ storeId })
      ])
      this.allCategoryFlat =
        String(catRes.data.code) === '1' && Array.isArray(catRes.data.data)
          ? catRes.data.data
          : []
      const list =
        String(dishRes.data.code) === '1' && Array.isArray(dishRes.data.data)
          ? dishRes.data.data
          : []
      this.dishOptions = list
        .filter((d: any) => d && d.id != null)
        .map((d: any) => ({
          id: Number(d.id),
          name: d.name || `商品#${d.id}`,
          image: d.image || '',
          price: d.price != null ? Number(d.price) : 0,
          description: d.description || '',
          displayCategoryIds: Array.isArray(d.displayCategoryIds)
            ? d.displayCategoryIds
                .map((id: any) => Number(id))
                .filter((id: number) => !Number.isNaN(id))
            : []
        }))
      this.rebuildDishCascaderTree()
    } catch (e) {
      this.dishOptions = []
      this.dishCascaderOptions = []
      this.allCategoryFlat = []
    }
  }

  private async init() {
    querySetmealById(this.$route.query.id).then((res) => {
      if (res && res.data && res.data.code === 1) {
        const data = res.data.data
        this.ruleForm = {
          id: data.id,
          name: data.name,
          mainDishId: data.mainDishId,
          bucketCount: data.bucketCount || 1,
          price: data.price,
          specText: data.specText || '',
          description: data.description || '',
          image: data.image || '',
          detailImage1: data.detailImage1 || '',
          detailImage2: data.detailImage2 || '',
          detailImage3: data.detailImage3 || '',
          detailImage4: data.detailImage4 || '',
          detailImage5: data.detailImage5 || '',
          sort: data.sort != null ? data.sort : 0,
          homeDisplay: data.homeDisplay || 0,
          flashSale: data.flashSale || 0,
          flashPrice: data.flashPrice != null ? data.flashPrice : '',
          flashEndTime: data.flashEndTime || '',
          status: data.status,
          storeId: data.storeId
        }
        this.homeDisplayOn = Number(data.homeDisplay) === 1
        this.flashSaleOn = Number(data.flashSale) === 1
        this.statusOn = Number(data.status) === 1
        const gifts = data.setmealGifts || data.gifts || []
        this.giftTable = gifts.map((g: any) => {
          const dish = this.dishOptions.find(
            (d) => Number(d.id) === Number(g.giftDishId)
          )
          return {
            giftDishId: g.giftDishId,
            name: g.giftDishName || (dish && dish.name) || '赠品',
            giftCopies: g.giftCopies || 1,
            giftValue: this.resolveGiftDisplayValue(g.giftValue, dish),
            sort: g.sort != null ? g.sort : 0
          }
        })
        this.syncMainUnitPrice()
        this.applyCoverFromSaved(data.image || '')
        this.detailImageUrl1 = data.detailImage1 || ''
        this.detailImageUrl2 = data.detailImage2 || ''
        this.detailImageUrl3 = data.detailImage3 || ''
        this.detailImageUrl4 = data.detailImage4 || ''
        this.detailImageUrl5 = data.detailImage5 || ''
        this.recalcStrikePrice()
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  /** 编辑回显：与主商品图相同则视为未手动上传 */
  private applyCoverFromSaved(savedImage: string) {
    const dishImg = this.selectedDishImage
    if (savedImage && dishImg && savedImage === dishImg) {
      this.resetCoverToDishDefault()
      return
    }
    if (savedImage) {
      this.coverManual = true
      this.imageUrl = savedImage
      this.ruleForm.image = savedImage
      return
    }
    this.resetCoverToDishDefault()
  }

  private resetCoverToDishDefault() {
    this.coverManual = false
    this.imageUrl = ''
    this.ruleForm.image = ''
  }

  @Watch('flashSaleOn')
  private onFlashSaleFlagChange(on: boolean) {
    if (on) {
      this.recalcStrikePrice()
      if (!this.ruleForm.flashEndTime) {
        this.ruleForm.flashEndTime = this.defaultFlashEndTime()
      }
    } else {
      this.ruleForm.flashEndTime = ''
      this.ruleForm.flashPrice = ''
    }
  }

  @Watch('ruleForm.price')
  private onPriceChange() {
    this.recalcStrikePrice()
  }

  @Watch('giftTable', { deep: true })
  private onGiftTableChange() {
    this.recalcStrikePrice()
  }

  private onHomeDisplayChange(on: boolean) {
    if (on) {
      this.statusOn = true
    }
  }

  private onFlashSaleChange(on: boolean) {
    if (on) {
      this.statusOn = true
      this.recalcStrikePrice()
      if (!this.ruleForm.flashEndTime) {
        this.ruleForm.flashEndTime = this.defaultFlashEndTime()
      }
    } else {
      this.ruleForm.flashEndTime = ''
      this.ruleForm.flashPrice = ''
    }
  }

  /** 抢购截止默认：当前时间 + 7 天 */
  private defaultFlashEndTime(): string {
    const d = new Date()
    d.setDate(d.getDate() + 7)
    const pad = (n: number) => (n < 10 ? `0${n}` : String(n))
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }

  private syncMainUnitPrice() {
    const dish = this.dishOptions.find(
      (d) => Number(d.id) === Number(this.ruleForm.mainDishId)
    )
    this.mainUnitPrice = dish ? Number(dish.price || 0) : 0
  }

  private onMainDishChange() {
    this.syncMainUnitPrice()
    const dish = this.dishOptions.find(
      (d) => Number(d.id) === Number(this.ruleForm.mainDishId)
    )
    if (dish && !this.ruleForm.specText) {
      this.ruleForm.specText = dish.description || dish.name || ''
    }
    // 新增/修改：换主商品后始终按单价×桶数重算
    this.recalcPrice()
    // 切换主商品后封面跟随商品图（可再手动上传覆盖）
    this.resetCoverToDishDefault()
  }

  private recalcPrice() {
    const buckets = Number(this.ruleForm.bucketCount || 0)
    if (buckets > 0 && this.mainUnitPrice >= 0) {
      this.ruleForm.price = (this.mainUnitPrice * buckets).toFixed(2)
    }
    this.recalcStrikePrice()
  }

  private sumGiftDisplayValue() {
    return (this.giftTable || []).reduce((sum: number, g: any) => {
      const copies = Number(g && g.giftCopies) > 0 ? Number(g.giftCopies) : 1
      const val = Number(g && g.giftValue)
      if (!Number.isFinite(val) || val < 0) return sum
      return sum + val * copies
    }, 0)
  }

  /** 划线价 = 套餐价 + 赠品展示价值 */
  private recalcStrikePrice() {
    if (!this.flashSaleOn) return
    const price = Number(this.ruleForm.price)
    const base = Number.isFinite(price) && price >= 0 ? price : 0
    this.ruleForm.flashPrice = (base + this.sumGiftDisplayValue()).toFixed(2)
  }

  private openGiftDialog() {
    this.pendingGiftDishId = null
    this.giftDialogVisible = true
  }

  private confirmAddGift() {
    if (!this.pendingGiftDishId) {
      return this.$message.error('请选择赠品商品')
    }
    if (
      this.giftTable.some(
        (g) => Number(g.giftDishId) === Number(this.pendingGiftDishId)
      )
    ) {
      return this.$message.warning('该赠品已添加')
    }
    const dish = this.dishOptions.find(
      (d) => Number(d.id) === Number(this.pendingGiftDishId)
    )
    if (!dish) {
      return this.$message.error('商品不存在')
    }
    this.giftTable.push({
      giftDishId: dish.id,
      name: dish.name,
      giftCopies: 1,
      giftValue: this.resolveGiftDisplayValue(null, dish),
      sort: this.giftTable.length
    })
    this.giftDialogVisible = false
  }

  /** 展示价值：优先已保存值，否则用商品售价，可再改 */
  private resolveGiftDisplayValue(saved: any, dish?: any) {
    if (saved !== '' && saved != null) {
      const n = Number(saved)
      return Number.isFinite(n) ? n : saved
    }
    if (!dish) return ''
    const p = Number(dish.price)
    return Number.isFinite(p) ? p : ''
  }

  public submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: boolean) => {
      if (!valid) return false
      if (!this.giftTable.length) {
        return this.$message.error('请至少添加一个实物赠品')
      }
      const storeId = this.currentStoreId || this.ruleForm.storeId
      if (!storeId) {
        return this.$message.error('请先在顶栏选择商户')
      }
      if (this.flashSaleOn) {
        this.recalcStrikePrice()
        const fp = Number(this.ruleForm.flashPrice)
        if (!Number.isFinite(fp) || fp <= 0) {
          return this.$message.error('划线价格需大于0，请检查套餐价和赠品价值')
        }
      }
      // 手动上传用自定义图；否则落主商品图（列表可直接展示）
      const image = this.coverManual
        ? this.imageUrl || ''
        : this.selectedDishImage || ''
      const params: any = {
        id: this.ruleForm.id,
        name: this.ruleForm.name,
        mainDishId: this.ruleForm.mainDishId,
        bucketCount: this.ruleForm.bucketCount,
        price: this.ruleForm.price,
        specText: this.ruleForm.specText,
        description: '',
        image,
        detailImage1: this.ruleForm.detailImage1 || '',
        detailImage2: this.ruleForm.detailImage2 || '',
        detailImage3: this.ruleForm.detailImage3 || '',
        detailImage4: this.ruleForm.detailImage4 || '',
        detailImage5: this.ruleForm.detailImage5 || '',
        sort: this.ruleForm.sort != null ? this.ruleForm.sort : 0,
        homeDisplay: this.homeDisplayOn ? 1 : 0,
        flashSale: this.flashSaleOn ? 1 : 0,
        flashPrice: this.flashSaleOn ? Number(this.ruleForm.flashPrice) : null,
        flashEndTime: this.flashSaleOn ? (this.ruleForm.flashEndTime || null) : null,
        // 首页展示/限时抢购必须上架才会对用户可见；否则按启售开关
        status: this.homeDisplayOn || this.flashSaleOn || this.statusOn ? 1 : 0,
        storeId,
        setmealGifts: this.giftTable.map((g, idx) => ({
          giftDishId: g.giftDishId,
          giftCopies: g.giftCopies || 1,
          giftValue:
            g.giftValue === '' || g.giftValue == null
              ? null
              : Number(g.giftValue),
          sort: idx
        }))
      }

      const req =
        this.actionType === 'add'
          ? addSetmeal(params)
          : editSetmeal(params)
      req
        .then((res: any) => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success(
              this.actionType === 'add' ? '特惠套餐添加成功！' : '特惠套餐修改成功！'
            )
            if (!st) {
              this.$router.push({ path: '/setmeal' })
            } else {
              ;(this as any).$refs.ruleForm.resetFields()
              this.giftTable = []
              this.resetCoverToDishDefault()
              this.detailImageUrl1 = ''
              this.detailImageUrl2 = ''
              this.detailImageUrl3 = ''
              this.detailImageUrl4 = ''
              this.detailImageUrl5 = ''
              this.homeDisplayOn = false
              this.flashSaleOn = false
              this.ruleForm = {
                id: undefined,
                name: '',
                mainDishId: null,
                bucketCount: 10,
                price: '',
                specText: '',
                description: '',
                image: '',
                detailImage1: '',
                detailImage2: '',
                detailImage3: '',
                detailImage4: '',
                detailImage5: '',
                sort: 0,
                homeDisplay: 0,
                flashSale: 0,
                flashPrice: '',
                flashEndTime: '',
                status: 0,
                storeId: null
              }
            }
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        })
        .catch((err: any) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  imageChange(value: any) {
    this.imageUrl = value || ''
    this.ruleForm.image = this.imageUrl
    // 有图视为手动上传；清空则回退主商品图
    this.coverManual = !!this.imageUrl
  }

  detailImageChange(index: number, value: any) {
    if (index === 1) {
      this.ruleForm.detailImage1 = value
      this.detailImageUrl1 = value || ''
    } else if (index === 2) {
      this.ruleForm.detailImage2 = value
      this.detailImageUrl2 = value || ''
    } else if (index === 3) {
      this.ruleForm.detailImage3 = value
      this.detailImageUrl3 = value || ''
    } else if (index === 4) {
      this.ruleForm.detailImage4 = value
      this.detailImageUrl4 = value || ''
    } else if (index === 5) {
      this.ruleForm.detailImage5 = value
      this.detailImageUrl5 = value || ''
    }
  }
}
